import AutoSlide from "./components/AutoSlide";


function App() {
  return (
    <>
      <AutoSlide />
    </>
  );
}

export default App;
